export default {
  pageName: '',
  classID: 0,

  userName: '',
  userMobile: '',
  userID: null,
}



// WEBPACK FOOTER //
// ./src/store/common/state.js